import { useQuery } from 'react-query';
import httpClient from '../datasources/httpClient';
/**
 * @param {string} backupId
 * @param {boolean} resume
 */
export default function useQueryReports({
  backupId,
  resume,
  offset,
  limit,
  dateInterval,
}) {
  return useQuery(
    [backupId, limit, offset, dateInterval],
    async () => {
      const response = await httpClient.get(
        `reports?${backupId ? `backupId=${backupId}&` : ''}${offset ? `$skip=${offset}&` : ''
        }${limit ? `$take=${limit}&` : ''}${dateInterval ? `dateInterval=${JSON.stringify(dateInterval)}&` : ''
        }resume=${resume}`,
      );

      return response.data;
    },
    {
      staleTime: 1000 * 60,
    },
  );
}
